import { render, staticRenderFns } from "./ProductComment.vue?vue&type=template&id=4c31a141&scoped=true&"
import script from "./ProductComment.vue?vue&type=script&lang=js&"
export * from "./ProductComment.vue?vue&type=script&lang=js&"
import style0 from "./ProductComment.vue?vue&type=style&index=0&id=4c31a141&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c31a141",
  null
  
)

export default component.exports